import styled from 'styled-components';
import { Colors } from '../../themes';

export const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 210px;
  height: 47px;
  border-radius: 190px;
  border: 2px solid ${Colors.button.main.border};
  box-shadow: 0px 3px 10px ${Colors.button.main.shadow};
  background: transparent
    linear-gradient(
      167deg,
      ${Colors.button.main.gradient.start} 0%,
      ${Colors.button.main.gradient.end} 100%
    )
    0% 0% no-repeat padding-box;
  ${props => props.disabled && `opacity: 0.6;`}
  ${props => props.fullWidth && `width: 100%;`}

  @media (max-width: 960px) {
    width: 80%;
    padding: 0 5%;
  }
`;

export const Icon = styled.img`
  margin-right: 10px;
  max-width: 22px;
`;

export const Text = styled.span`
  font-size: 1rem;
  font-weight: 400;
  color: ${Colors.button.main.text};
`;
